namespace GeniuzPOS.Product {
    export interface CsBrandTypeForm {
        BrandTypeCode: Serenity.StringEditor;
        BrandTypeName: Serenity.StringEditor;
    }

    export class CsBrandTypeForm extends Serenity.PrefixedContext {
        static formKey = 'Product.CsBrandType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsBrandTypeForm.init)  {
                CsBrandTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CsBrandTypeForm, [
                    'BrandTypeCode', w0,
                    'BrandTypeName', w0
                ]);
            }
        }
    }
}
